import { TExportSelectedData } from './export-data';

export const csv_export_data: TExportSelectedData[] = [];
